import React from 'react';

import { Typography } from '@vtblife/uikit';

import type { NewBuildingQuiz } from '@search/graphql-typings';
import classname from '@search/classname/src';
import { CoreSvgSpriteIcon } from '@search/vtbeco-frontend-core/view/common/components/CoreSvgSpriteIcon/CoreSvgSpriteIcon';
import { CURRENT_YEAR } from '@search/vtbeco-frontend-core/domain/newbuilding/libs/constants';

import useQuizBuilderState from '../../common/QuizBuilder/useQuizBuilderState';

import QuizBuilderFinalStep from './QuizBuilderFinalStep';
import QuizBuilderSidebar from './QuizBuilderSidebar';
import QuizBuilderStep from './QuizBuilderStep';

import './styles.css';

const cn = classname.bind(null, 'QuizBuilder');

const QuizBuilder = ({ quiz }: {
    quiz: NewBuildingQuiz;
}) => {
    const {
        stepIndex,
        currentStepNumber,
        sortedSteps,
        totalSteps,
        handleNextStep,
        goToPrevStep,
        goToLastStep,
        result,
        updateStepResult,
        quizId
    } = useQuizBuilderState(quiz);

    return (
        <div className={cn()}>
            <div className={cn('header')}>
                <CoreSvgSpriteIcon
                    name='M2Logo'
                    width={58}
                    height={52}
                />
            </div>
            <div className={cn('main')}>
                {
                    currentStepNumber > totalSteps ? (
                        <QuizBuilderFinalStep
                            lastStepData={quiz.lastStep}
                            quizId={quizId}
                            result={result}
                            emailData={quiz.email}
                        />
                    ) : (
                        <QuizBuilderStep
                            key={stepIndex}
                            currentStepNumber={currentStepNumber}
                            stepData={sortedSteps[stepIndex]}
                            stepResult={result[stepIndex]}
                            totalSteps={totalSteps}
                            updateStepResult={updateStepResult}
                            goToNextStep={handleNextStep}
                            goToPrevStep={goToPrevStep}
                        />
                    )
                }
                <QuizBuilderSidebar
                    sidebarData={quiz.sidebar}
                    goToLastStep={goToLastStep}
                />
            </div>
            <div className={cn('footer')}>
                <Typography
                    variant='small'
                    color='minor'
                >
                    {/* eslint-disable-next-line max-len */}
                    &copy;&nbsp;Метр квадратный, {CURRENT_YEAR}. Сервис поиска недвижимости, ипотечные предложения и&nbsp;ремонт в&nbsp;один клик. Общество с&nbsp;ограниченной ответственностью &laquo;Экосистема недвижимости &laquo;Метр квадратный&raquo;, ОГРН&nbsp;1197746330132, Адрес: 127055, г.&nbsp;Москва, улица Лесная, дом&nbsp;43, под.&nbsp;VI, пом.&nbsp;4Ч
                </Typography>
            </div>
        </div>
    );
};

export default QuizBuilder;
